export default "__VITE_ASSET__BBga4KTA__"